import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Footer } from "../components/Footer";
import { useLang } from "../context/LanguageContext";
import { earlyBird } from "../lib/earlyBird";
import { EarlyBirdCountdown } from "../components/LiveInstructors";
import { DiplomaCard } from "../components/DiplomaCard";
import api from "../lib/api";
import useSeo from "../hooks/useSeo";

const fade = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.15 },
  transition: { duration: 0.5 },
};

export default function Diplomas() {
  const { t, lang } = useLang();
  const [programs, setPrograms] = useState([]);

  useSeo({
    title: lang === "en" ? "LIVE Diplomas | SportScience Academy" : "LIVE Διπλώματα | SportScience Academy",
    description: t("diplomas.subtitle"),
  });

  useEffect(() => {
    api.get("/courses").then((r) => setPrograms(r.data.filter((c) => c.mode === "live"))).catch(() => {});
  }, []);

  const eb = programs.find((p) => earlyBird(p).active);

  return (
    <>
      <section className="max-w-7xl mx-auto px-5 sm:px-6 pt-28 md:pt-32 pb-20" data-testid="diplomas-page">
        <motion.div {...fade} className="max-w-3xl">
          <span className="eyebrow">
            <span className="w-7 h-px bg-[#1D4ED8]" />
            {t("live.badge")}
          </span>
          <h1 className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl mt-5 text-[#0B1B3A]" data-testid="diplomas-title">
            {t("diplomas.title")}
          </h1>
          <p className="text-[#475569] mt-5 text-base sm:text-lg">{t("diplomas.subtitle")}</p>
          <p className="text-[#1D4ED8] font-bold mt-4" data-testid="diplomas-async-note">{t("live.asyncShort")}</p>
          {eb && <div className="mt-6"><EarlyBirdCountdown until={eb.early_bird_until} /></div>}
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-14">
          {programs.map((p, i) => (
            <DiplomaCard key={p.id} program={p} delay={Math.min(i, 3) * 0.08} />
          ))}
        </div>
      </section>
      <Footer />
    </>
  );
}
